import { render, staticRenderFns } from "./ConsumerDashboard.vue?vue&type=template&id=5e976a00&scoped=true&"
import script from "./ConsumerDashboard.vue?vue&type=script&lang=js&"
export * from "./ConsumerDashboard.vue?vue&type=script&lang=js&"
import style0 from "./ConsumerDashboard.vue?vue&type=style&index=0&id=5e976a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e976a00",
  null
  
)

export default component.exports